import script from "./NextChallengeCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NextChallengeCard.vue?vue&type=script&setup=true&lang=ts"

import "./NextChallengeCard.vue?vue&type=style&index=0&id=1ab0ebf8&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab0ebf8"]])

export default __exports__